<template>
  <el-tabs v-model="activeName" class="t_tabs" @tab-change="handleClick">
    <el-tab-pane label="权限管理" name="1">
      权限管理
    </el-tab-pane>
    <el-tab-pane label="成员列表" name="2">
    </el-tab-pane>
  </el-tabs>
  <!-- 成员列表 -->
  <div v-if="activeName==2" class="t_buspeople_box">
    <div class="t_people_treebox">
      <peopletree />
    </div>
    <div class="t_people_listbox">
      <peoplelist />
    </div>
  </div>
</template>

<script setup>
import { ref, reactive,  provide, onBeforeMount, onMounted,watch } from 'vue'
import peopletree from '../components/buspeople/peopletree.vue';
import peoplelist from '../components/buspeople/peoplelist.vue';
//默认选中tab
const activeName = ref('2')
//tab切换事件
const handleClick = (i) => {
  console.log(i)
  activeName.value=i
}

   
</script>
<style scoped>
  .t_tabs{
    padding: 20px;
  }
  .t_buspeople_box{
   
    display: flex;
    height: calc(100% - 100px);
    
  }
  .t_people_treebox{
    border-right:1px solid #DDDDDD;
    width: 300px;
    padding: 0 20px;
    overflow: auto;
    height: 100%;
  }
  .t_people_listbox{
    padding: 0 20px;
    flex: 1;
    overflow: auto;
    height: 100%;
  }
  :deep(.el-tabs__item.is-active) {
    color:#4F46E5
  }
  :deep(.el-tabs__active-bar) {
    background-color: #4F46E5;
  }
</style>
